import { toast } from 'react-toastify'

interface Types {
  url: string
  token: string | null
  mutate: (value: string) => void
  destroyToken: () => void
}

export const deleteResourceById = async ({ url, token, mutate, destroyToken }: Types) => {
  const resource = url.startsWith('news/article') ? 'Article' : 'Sale'
  try {
    const response = await fetch(`${process.env.REACT_APP_API_HOST}/api/${url}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (response.ok) {
      toast.success(`${resource} has been deleted.`)
      mutate(url.startsWith('news/article') ? 'news/article' : 'sales/offer')
    }

    if (response.status === 401) {
      destroyToken()
      throw new Error('Your session has expired. Please log in.')
    }

    if (!response.ok) {
      throw new Error(`Failed to delete ${resource}. Please try again.`)
    }
  } catch (err) {
    if (err instanceof Error) {
      toast.error(err.message)
    }
  }
}
